import { useContext } from 'react'
import { PassContext } from '../pass-context'
import {AppContext} from '/providers/app-context'

import EventTicket from './fronts/event-ticket'
import Transit from './fronts/transit'
import Flight from './fronts/flight'
import Offer from './fronts/offer'
import Loyalty from './fronts/loyalty'
import GiftCard from './fronts/gift-card'
import Generic from './fronts/generic'

// import Access from './fronts/access'
// import Private from './fronts/private'

const googlePassTypes = {
  
  eventTicket : EventTicket,
  
  giftCard : GiftCard,
  loyalty : Loyalty,
  offer : Offer,
  stamp : Generic,
  
  business : Offer,
  membership : Generic,
  insurance : Generic,
  
  transit : Transit,
  
  key : Generic,
  
  flight : Flight,
  
  generic : Generic,
}

export default ({backgroundColour,googleDarkBackgroundColour,fgColour}) => {
  const { passType } = useContext(PassContext)
  const {user} = useContext(AppContext)
  
  let PassTypeComponent = googlePassTypes[passType]

  return (
    <PassTypeComponent show={user.preferences.show_standard_items} backgroundColour={backgroundColour} googleDarkBackgroundColour={googleDarkBackgroundColour} fgColour={fgColour}/>
  )
}


